<template>
  <v-container id="">
    <v-layout row wrap>
      <v-flex xs12 sm12 md12>
        <v-card class="table" elevation="4">
          <v-toolbar flat elevation="4">
            <v-card class="icon">
              <v-icon
                style="margin-left: 30px; margin-top: 25px"
                color="white"
                x-large=""
                >mdi-map-marker-plus</v-icon
              >
            </v-card>
            <div class="usuario">Zonas</div>
            <v-spacer></v-spacer>
            <v-dialog v-model="dialog" max-width="500px" persistent>
              <template v-slot:activator="{ on }">
                <v-btn dark class="botonplus" v-on="on"
                  ><v-icon color="white">mdi-plus-thick</v-icon></v-btn
                >
              </template>
              <v-card>
                <v-card-title class="nav">
                  <span class="headline" style="color: white"
                    ><v-icon color="white">mdi-map-marker-plus</v-icon>
                    {{ formTitle }}</span
                  >
                </v-card-title>
                <!-- componente del modal para agregar y actualizar -->
                <v-card-text>
                  <v-container grid-list-md>
                    <v-layout wrap>
                      <v-flex xs12 sm12 md12>
                        <v-text-field
                          v-model="editedItem.nombre"
                          label="Nombre"
                        ></v-text-field>
                      </v-flex>
                    </v-layout>
                  </v-container>
                </v-card-text>
                <!-- botones para cancelar y agregregar y validacion de campos vacios -->
                <v-card-actions>
                  <v-spacer></v-spacer>
                  <v-btn color="#1D3C7F" @click="close">Cancelar</v-btn>
                  <v-btn
                    color="#1D3C7F"
                    @click="save"
                    :disabled="!editedItem.nombre"
                    >Guardar</v-btn
                  >
                </v-card-actions>
                <!-- <pre>{{editedItem}}</pre>  -->
              </v-card>
            </v-dialog>
          </v-toolbar>
          <br />
          <v-text-field
            v-model="search"
            append-icon="mdi-magnify"
            label="Buscar zona"
            class="text-field"
            single-line
            color="#111c3d"
          ></v-text-field>
          <br />
          <v-data-table
            :headers="headers"
            :items="zonas"
            :search="search"
            style="border: 2px solid #111c3d"
            class="elevation-3"
          >
            <!-- tabla donde se pintan los datos obtenidos del arreglo -->
            <template v-slot:[`item.action`]="{ item }">
              <v-icon small class="mr-2" @click="editItem(item)">
                mdi-pencil
              </v-icon>
            </template>
            <template v-slot:no-data>
              <v-alert :value="true" color="#111c3d" icon="mdi-alert" outlined
                >No se encontro su busqueda</v-alert
              >
            </template>
          </v-data-table>
          <!-- alertas de las acciones que se hacen -->
          <v-snackbar
            v-model="snackbar"
            :bottom="y === 'bottom'"
            :left="x === 'left'"
            :multi-line="mode === 'multi-line'"
            :right="x === 'right'"
            :timeout="timeout"
            :top="y === 'top'"
            :vertical="mode === 'vertical'"
            color="#294697"
            style="color: white"
          >
            {{ text }}
            <v-btn color="#294697" depressed @click="snackbar = false"
              >Cerrar</v-btn
            >
          </v-snackbar>
        </v-card>
      </v-flex>
    </v-layout>
  </v-container>
</template>

<script>
import axios from "axios";
import env from "../env";
export default {
  data() {
    return {
      show: false,
      snackbar: false,
      y: "top",
      x: null,
      mode: "",
      timeout: 6000,
      text: "",
      search: "",
      zonas: [],
      rules: {
        required: (value) => !!value || "Required.",
        counter: (value) => value.length <= 20 || "Maximo 20 characteres",
        email: (value) => {
          const pattern = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
          return pattern.test(value) || "Invalido e-mail.";
        },
      },
      dialog: false,
      headers: [
        {
          text: "ID",
          align: "left",
          value: "idZona",
          align: "center",
          class: "column",
        },
        {
          text: "Zona",
          value: "nombreZona",
          align: "center",
          class: "column",
        },
      ],
      defaultItem: {
        id: "",
        nombre: "",
      },
      editedIndex: -1,
      editedItem: {
        id: "",
        nombre: "",
      },
    };
  },
  computed: {
    formTitle() {
      return this.editedIndex === -1 ? "Nueva Zona" : "Editar Zona";
    },
  },
  watch: {
    dialog(val) {
      val || this.close();
    },
  },

  mounted() {
    this.obtenerPuntos();
  },
  methods: {
    obtenerPuntos() {
      axios.get(`${env.endpoint}user/consultarZonas`).then((res) => {
        this.zonas = res.data;
      });
    },
    editItem(item) {
      this.editedIndex = this.zonas.indexOf(item);
      this.editedItem = Object.assign({}, item);
      this.dialog = true;
    },
    //TODO modificar guardado
    save() {
      axios
        .get(
          `${env.endpoint}user/crearZona?nombreZona=${this.editedItem.nombre.toUpperCase()}`
        )
        .then((res) => {
          this.text = "Zona registrada con éxito.";
          this.snackbar = true;
          this.obtenerPuntos();
        })
        .catch((e) => {
          this.text =
            "Ha ocurrido un error, intente de nuevo, si el problema persiste comuníquese con el área de sistemas.";
          this.snackbar = true;
        });
      this.close();
      this.obtenerPuntos();
    },
    close() {
      this.dialog = false;
      setTimeout(() => {
        this.editedItem = Object.assign({}, this.defaultItem);
        this.editedIndex = -1;
      }, 300);
    },
  },
};
</script>